import React from 'react';
import appLib from "../../libs/appLib.mjs";
import {Input} from "reactstrap";
import "./MultiLangLabelField.css";

const prefix='MultiLangLabelField';

const MultiLangLabelField = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			data: props.value || {},
			langs: appLib.languages()
		}
		this.setValue = this.setValue.bind(this);
	}
	/**
	 * @param {Event|HTMLFormElement|string} field
	 * @param {string|number|null} [value]
	 * @return {void}
	*/
	setValue = (field, value ) => {
		if ( field?.target ) field = field.target;
		if ( field?.name ) {
			value = field.value;
			field = field.name;
		}
		let data = this.state.data;
		if ( ! value ) {
			delete data[field];
		} else {
			data[field] = value;
		}
		this.setState({ data: data }, ()=>{ this.props.onChange( Object.keys( data ).length ? data : undefined ); })
	}

	render() {
		if ( ! this.props.langs ) return '';
		return(
			<div className={prefix}>
				{ this.state.langs.filter( l => this.props.langs.includes(l.id)).map((l,i) => (
					<div key={i}>
						<span>
							<img src={l.flag} title={l.name} alt={l.name}/>
						</span>
						<Input
							type={ this.props.long ? "textarea" : "text" }
							name={l.id}
							value={this.state.data[l.id] || ''}
							onChange={ this.setValue }
						/>
					</div>
				))}
			</div>
		)
	}
}

export default MultiLangLabelField;